import { Directive, forwardRef, Input } from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  AsyncValidatorFn,
  NG_ASYNC_VALIDATORS,
  ValidationErrors,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { UserDAO } from '../../../core/services/dao/userDAO';
import {
  debounceTime,
  distinctUntilChanged,
  first,
  map,
  switchMap,
} from 'rxjs/operators';

export interface NameCheckReturn {
  emailDuplicate: boolean;
}

@Directive({
  selector: '[enrollEmailDuplicate]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: forwardRef(() => EnrollEmailDuplicateDirective),
      multi: true,
    },
  ],
})
export class EnrollEmailDuplicateDirective implements AsyncValidator {
  @Input() enrollEmailDuplicate: Observable<string>;
  currentUserId: number;

  constructor(private userDAO: UserDAO) {
    if (this.userDAO.getCurrentUser()) {
      this.currentUserId = this.userDAO.getCurrentUser().id;
    }
  }

  validate(control: AbstractControl): Observable<ValidationErrors> {
    return this.enrollEmailDuplicate.pipe(
      debounceTime(300), // wait for 300 ms of no user input
      distinctUntilChanged(), // only if value has changed
      switchMap((emailString: string) =>
        this.userDAO.checkEmail<NameCheckReturn>(
          emailString,
          this.currentUserId,
        ),
      ), // send our request but only care about the last one in flight
      map((data: NameCheckReturn) => {
        return data.emailDuplicate
          ? { emailDuplicate: data.emailDuplicate }
          : null;
      }), // transform result
      first(), // You need this for displaying template driven form errors
    );
  }
}
